module.exports = "<div class=\"container\">\n  <app-header></app-header>\n\n  <router-outlet></router-outlet>\n\n  <app-footer></app-footer>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/fonzi-module/fonzi.component.html
// module id = 742
// module chunks = 1